(function($) {
$.widget("ca.caMultiAutocomplete", {
    options: {
        name : 'multiAutocomplete',
        url : '/layout/user-autocomplete',
        data : {},
        limit : 5,
        placeholder : 'add one more',
        changeable : true,
        inputMinWidth : 100,
        uniqueItems : false,
        selectedItems : [],
        anyItems: false,
        idIndex: 1,
        notFoundText: 'User not found'
    },

    _create: function() {
        var self = this;
        var options = self.options;

        var input = self.element.find('[type=text]');
        options.selectedItems = [];
        
        if (self.options.uniqueItems) {
            var items = self.element.find('input[type="hidden"]');

            items.each(function (i, e) {
                if (e.value) {
                    options.selectedItems.push(e.value);
                }
            });
            
            options.data.skip = options.selectedItems;
        }

        if (options.anyItems) {
            input.caText({
                placeholder: options.selectedItems.length ? '' : options.placeholder,
                useEmptyPlaceHolder: true
            });
            
            var idIndex = options.idIndex;
            
            input.on('keypress', function (event) {
                var keyCode = event.which ? event.which : event.keyCode;
                if (keyCode == 10 || keyCode == 13) {
                    input.trigger('caautocompletechange', {item: {id: 'new_' + idIndex, label: input.val()}});
                    idIndex++;
                }
            });
        } else {
            input.caAutocomplete({
                url : options.url,
                limit : options.limit,
                data : options.data,
                placeholder: options.selectedItems.length ? '' : options.placeholder,
                useEmptyPlaceHolder: true,
                notFoundText: options.notFoundText
            });
        }

        input.bind('caautocompletechange', function(event, ui) {
            if (ui.item) {
                var li = $('<li>' +
                '<span>' + ui.item.label + '</span><a href="#"></a>' +
                    '<input type="hidden" value="' + ui.item.id + '" name="' + options.name + '[]" />' +
                '</li>');

                self.element.find('ul li:last-child').before(li);

                self._trigger("addItem",{}, {item : ui.item});
                self.options.selectedItems.push(ui.item.id);

                if (self.options.uniqueItems) {
                    self.options.data.skip = self.options.selectedItems;
                    
                    if (!self.options.anyItems) {
                        input.caAutocomplete('option', 'data', self.options.data);
                    }
                }

                input.caText({
                    placeholder: options.selectedItems.length ? '' : options.placeholder,
                    useEmptyPlaceHolder: true
                });

                if (!self.options.anyItems) {
                    input.caAutocomplete('clearItem', false);
                } else {
                    input.val('');
                }
                
                self._adjustInputWidth();
                
                return false;
            }
        });

        // fix to call change event
        input.bind('caautocompleteselect', function(e, ui){
            setTimeout(function() {
                input.blur();
                input.focus();
            }, 1);
        });

        self._adjustInputWidth();
        self.element.on('click',function() {
            self._adjustInputWidth();
            input.focus();
            return false;
        });

        self.element.on('click', 'li a', function() {
            var li = $(this).closest('li');

            var itemId = li.find('[type=hidden]').val();
            li.remove();
            self._adjustInputWidth();
            self._trigger("removeItem", {}, {item : {id : itemId}});
            
            var arrayId = self.options.selectedItems.indexOf(itemId);
            
            if (arrayId != -1) {
                self.options.selectedItems.splice(arrayId, 1);
            }

            if (self.options.uniqueItems) {
                self.options.data.skip = self.options.selectedItems;
                self.element.find('[type=text]').caAutocomplete('option', 'data', self.options.data);
            }
            
            input.caText({
                placeholder: options.selectedItems.length ? '' : options.placeholder,
                useEmptyPlaceHolder: true
            });

            input.focus();
            return false;
        });
        this.setChangeable(this.options.changeable);
    },

    _adjustInputWidth : function() {
        var input = this.element.find('input[type=text]');
        input.width(this.options.inputMinWidth - 5);
        var pWidth = this.element.width();
        var availableWidth = pWidth - input.position().left;
        if(availableWidth > this.options.inputMinWidth) {
            input.width(availableWidth - 20);
        } else {
            input.width(this.options.inputMinWidth - 20);
        }
    },
    
    setChangeable: function(changeable) {
        this.options.changeable = changeable ? true : false;
        if (changeable) {
            this.element.find('[type=text]').show();
            this.element.parent().find('.ca-multi-autocomplete').find('a').show();
            this._adjustInputWidth();
        } else {
            this.element.find('[type=text]').hide();
            this.element.parent().find('.ca-multi-autocomplete').find('a').hide();
        }
    }
});
})(jQuery);
